<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body" id="pushbtnbox">
				<Header @getTime="getTime"/>
				<div class="pushbtn" style=" position: absolute;top:0.84rem;left:57%">
					<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
					<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
				</div>
				<div class="brand_content">
					<div class="brand_content_top">
						<div class="brand_pie">
							<create ref="creatLeft"/>
						</div>
						<div class="brand_map">
							<citys ref="map"/>
						</div>
						<div class="brand_pie">
							<manage ref="manageRight"/>
						</div>
					</div>
					<div class="brand_content_bottom">
						<div class="brand_bar1">
							<apply ref="applyLeft"/>
						</div>
						<div class="brand_bar2">
							<protect ref="protectRight"/>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>
	import "@/assets/scss/brand.scss";
	import drawMixin from "../utils/drawMixin";
	import Header from './header'
	import create from './brand/create.vue'
	import manage from './brand/manage.vue'
	import apply from './brand/apply.vue'
	import protect from './brand/protect.vue'
	import citys from './brand/map.vue'
	import {getPageTwoData} from '@/utils/api.js'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading: true, //加载状态
				timer:'', //定时器
				inpause:false, // 是否继续
			};
		},
		components: {
			Header,
			create,
			manage,
			apply,
			protect,
			citys
		},
		mounted() {
			this.timer = setTimeout(() =>{
				if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
					this.$router.push('/three');
				}else{
					console.log(2,'已销毁')
				}
			},30000)
			this.cancelLoading();
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			// 获取年月
			getTime(val){
				var params = {}
				if(Number(val.year) >= 2022 && Number(val.mon) > 9){
					params = {
						year:'2022',
						month:'9',
					}
				}else{
					params = {
						year:val.year,
						month:val.mon,
					}
				}
				// console.log(params)
				getPageTwoData(params).then(res=>{
					if(res.status == 200){
						this.$refs.creatLeft.getData(res.data.page2.cz,res.data.sp_list_top10);
						this.$refs.manageRight.getData(res.data.wf_list_top10);
						this.$refs.map.getData(res.data.page2.map_list);
						this.$refs.applyLeft.getData(res.data.yy);
						this.$refs.protectRight.getData(res.data.bh,res.data.bh_list);
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			},			
			pocBtn(){
				this.inpause = !this.inpause;
				console.log(this.inpause)
				if(this.inpause){
					console.log("cleartimeout")
					clearTimeout(this.timer);
				}else{
					this.timer = setTimeout(() =>{
						if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
							this.$router.push('/three');
						}else{
							console.log(2,'已销毁')
						}
					},30000)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.bg {
		background-image: url("../assets/two.png");
	}
</style>
